// src/contexts/sectorDashboardV2/sectorTokenAnalyticsContext.ts
import { createContext, useContext } from "react";

export type SectorTokenAnalyticsContextValue = {
  categoryId: number;
  /** Aligned date axis for sector token price series (YYYYMMDD integers) */
  priceDates: number[];
  /** Price history by ticker (raw price_close series, aligned by index) */
  pricesByTicker: Map<string, Array<number | null>>;
  /** Daily returns derived from price history */
  returnsByTicker: Map<string, number[]>;
  btcReturns: number[] | null;
  ethReturns: number[] | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
};

export const SectorTokenAnalyticsContext =
  createContext<SectorTokenAnalyticsContextValue | null>(null);

export function useSectorTokenAnalytics(): SectorTokenAnalyticsContextValue {
  const ctx = useContext(SectorTokenAnalyticsContext);
  if (!ctx) {
    throw new Error(
      "useSectorTokenAnalytics must be used within SectorTokenAnalyticsProvider"
    );
  }
  return ctx;
}


